const padTwo = (value: number) => value.toString().padStart(2, '0');

export const formatDateTime = (value: string | Date | null | undefined, includeSeconds = false) => {
  if (!value) return '';

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const datePart = [
    date.getFullYear(),
    padTwo(date.getMonth() + 1),
    padTwo(date.getDate()),
  ].join('-');

  const timeParts = [padTwo(date.getHours()), padTwo(date.getMinutes())];
  if (includeSeconds) {
    timeParts.push(padTwo(date.getSeconds()));
  }

  return `${datePart} ${timeParts.join(':')}`;
};
